import { render, staticRenderFns } from "./ModalFullScreen.vue?vue&type=template&id=035dd806"
import script from "./ModalFullScreen.vue?vue&type=script&lang=ts"
export * from "./ModalFullScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035dd806')) {
      api.createRecord('035dd806', component.options)
    } else {
      api.reload('035dd806', component.options)
    }
    module.hot.accept("./ModalFullScreen.vue?vue&type=template&id=035dd806", function () {
      api.rerender('035dd806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalFullScreen.vue"
export default component.exports